import { FocusEvent, MouseEvent, useRef } from "react";
import {
  PickersTextField,
  PickersTextFieldProps,
} from "@mui/x-date-pickers/PickersTextField";

// `keepOpenDuringFieldFocus` opens a picker on field focus, but only closes it
// on click-away — tabbing into the next picker would leave both open. Marking
// keyboard focus as handled skips that trigger; focus that follows a mousedown
// still opens, and the click closes any other open picker.
export const ClickToOpenPickerTextField = (props: PickersTextFieldProps) => {
  const isPointerFocus = useRef(false);

  return (
    <PickersTextField
      {...props}
      onMouseDown={(event: MouseEvent<HTMLDivElement>) => {
        isPointerFocus.current = true;
        props.onMouseDown?.(event);
      }}
      onFocus={(event: FocusEvent<HTMLDivElement>) => {
        if (!isPointerFocus.current) event.preventDefault();
        isPointerFocus.current = false;
        props.onFocus?.(event);
      }}
      onBlur={(event: FocusEvent<HTMLDivElement>) => {
        isPointerFocus.current = false;
        props.onBlur?.(event);
      }}
    />
  );
};
